import React, { useState } from "react";
import { safeHttpUrl } from "../common/format";
import "../warranty.css";

const httpsOnly = (value) => {
  const url = safeHttpUrl(value);
  return url !== null && url.startsWith("https:") ? url : null;
};

// A small square preview. No address, an address that is not https, or an image that fails to
// load all show the same placeholder, so a broken link is visible before the app shows it.
const Preview = ({ src, size, alt }) => {
  const [failed, setFailed] = useState(false);
  const url = httpsOnly(src);
  const style = { width: size, height: size };
  if (url === null || failed) {
    return (
      <span
        className="warranty-thumb is-empty"
        style={style}
        role="img"
        aria-label={url === null ? "No image" : "Image could not be loaded"}
        title={url === null ? "No image" : "Image could not be loaded"}
      >
        <i className="bi bi-image" aria-hidden="true"></i>
      </span>
    );
  }
  return (
    <img
      className="warranty-thumb"
      style={style}
      src={url}
      alt={alt}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
    />
  );
};

// Keyed by the address, so a new address gets a fresh try after an earlier one failed.
const ImagePreview = ({ src, size = 40, alt = "" }) => (
  <Preview key={typeof src === "string" ? src : ""} src={src} size={size} alt={alt} />
);

export default ImagePreview;
